// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; // Import storage

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAmGq8yUKwWsUVTb0KssNbdsbs9-8-KLrQ",
    authDomain: "aweitflix.com",
    projectId: "aweitflix",
    storageBucket: "aweitflix.firebasestorage.app",
    messagingSenderId: "265944094333",
    appId: "1:265944094333:web:19bafd0a8cf08997918314",
    measurementId: "G-PFYCRSF7DK"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app); // Initialize and export storage
export const analytics = getAnalytics(app); // Initialize and export storage
